<script>
  import './style.scss';
  import template from './template.html';
  import { CalendarCheckIcon, RhombusIcon, ChevronUpIcon, ChevronDownIcon } from '../icons.js';

  export default {

    props: {
      title: {
        default: '',
        type: String
      },

      options: {
        type: Object
      },

      isActive: {
        default: false,
        type: Boolean
      },

      showDownload: {
        default: false,
        type: Boolean
      },

      orderId: {
        default: 0,
        type: Number
      },

      fileType: {
        default: '',
        type: String
      },

      itemCount: {
        default: 0,
        type: Number
      }

    },

    created () {},

    computed: {},

    methods: {

      toggleAccordian (state) {
        this.toggleIsActive = state;
      }
    },

    template,

    data () {

      return {
        reviewers: [],

        toggleIsActive: this.isActive
      }
    },

    components: {
      CalendarCheckIcon
      ,RhombusIcon
      ,ChevronDownIcon
      ,ChevronUpIcon
    }
  };
</script>
